import React from "react";

const Users: React.FC = () => {
  return (
    <div className="page">
      <h2 className="page-title">Users</h2>
      <p>Bienvenido al sistema de gestión de inventario.</p>
    </div>
  );
};

export default Users;
